import { makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { ActivityTagItem } from '@spotify/plugin-confidence-activity-react';

import { describeCriterion, hasChanged } from './formatting';
import { Criterion } from './types';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    gap: 'var(--encore-spacing-tighter-2)',
    alignItems: 'center',
    padding: 'var(--encore-spacing-tighter-4) 0',
    fontSize: '0.8125rem',
  },
  unchanged: {
    opacity: 0.5,
  },
});

export const CriterionDiff = ({
  oldCriterion,
  newCriterion,
}: {
  oldCriterion: Criterion | undefined;
  newCriterion: Criterion | undefined;
}) => {
  const classes = useStyles();

  const criterion = newCriterion ?? oldCriterion;
  if (!criterion) return null;

  const changed = hasChanged(oldCriterion, newCriterion);
  const isRemoved = oldCriterion && !newCriterion;

  const info = describeCriterion(criterion);

  if (!changed) {
    return (
      <div className={classNames(classes.root, classes.unchanged)}>
        <ActivityTagItem
          smallFont
          tagLabel={info.tagLabel}
          defaultValue={info.value}
        />
      </div>
    );
  }

  const oldInfo = oldCriterion ? describeCriterion(oldCriterion) : null;
  const newInfo = newCriterion ? describeCriterion(newCriterion) : null;

  return (
    <div
      className={classNames(classes.root, {
        [classes.unchanged]: isRemoved,
      })}
    >
      <ActivityTagItem
        smallFont
        tagLabel={info.tagLabel}
        oldValue={oldInfo?.value}
        newValue={newInfo?.value}
      />
    </div>
  );
};
